import "./NavLogo.scss";
import logo from "../../assets/logo/logo.png";
import { Link } from "react-router-dom";

const NavLogo = () => {
  return (
    <Link to="/">
      <img className="nav-logo" src={logo} alt="logo" />
    </Link>
  );
};

export default NavLogo;
